import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/app/src/lib/providers/i18n.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/app/src/lib/providers/polyfills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/app/src/lib/providers/query.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/app/src/styles/style.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../styles/fonts/InnovatorGrotesk-VF.woff2\",\"weight\":\"100 900\",\"variable\":\"--innovator\"}],\"variableName\":\"uiFont\"}");
